/* ============================================
   Seek Key — Cart Dropdown JS
   Replaces the native cart drawer with a compact dropdown.
   ============================================ */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.bindCartIcon();
  }

  bindCartIcon() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle(cartLink);
    });
  }

  toggle(triggeredBy) {
    if (this.classList.contains('active')) {
      this.close();
    } else {
      this.open(triggeredBy);
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    /* Close account dropdown if open */
    var accountDD = document.getElementById('sk-account-dropdown');
    if (accountDD) accountDD.classList.remove('sk-dd-show');
    this.positionDropdown();
    this.classList.add('active');
    document.body.addEventListener('click', this.onBodyClick);
    if (window.innerWidth < 750) {
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    this.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');
  }

  positionDropdown() {
    const icon = document.querySelector('#cart-icon-bubble');
    const panel = this.querySelector('.sk-cart-dropdown__panel');
    if (!icon || !panel) return;

    if (window.innerWidth < 750) {
      panel.style.position = 'fixed';
      panel.style.top = 'auto';
      panel.style.right = '0';
      panel.style.bottom = '0';
      panel.style.left = '0';
      panel.style.maxWidth = '100%';
      panel.style.maxHeight = '85vh';
      panel.style.borderRadius = '8px 8px 0 0';
      return;
    }

    var rect = icon.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.top = (rect.bottom + 8) + 'px';
    panel.style.right = Math.max(16, window.innerWidth - rect.right - 8) + 'px';
    panel.style.bottom = 'auto';
    panel.style.left = 'auto';
    panel.style.maxWidth = '420px';
    panel.style.maxHeight = 'calc(100vh - ' + (rect.bottom + 24) + 'px)';
    panel.style.borderRadius = '4px';
  }

  /* renderContents is called by product-form.js after a successful add-to-cart.
     parsedState.sections contains pre-rendered HTML from Shopify's Section Rendering API.
     This is safe HTML generated server-side by Shopify (not user input). */
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(function(section) {
      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      /* Section Rendering API returns trusted Shopify-rendered HTML */
      var parsed = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
      var source = parsed.querySelector(section.selector || '.shopify-section');
      if (source) {
        sectionElement.replaceChildren();
        while (source.firstChild) {
          sectionElement.appendChild(source.firstChild);
        }
      }
    });

    if (this.classList.contains('is-empty')) {
      this.classList.remove('is-empty');
    }
    var drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems && drawerItems.classList.contains('is-empty')) {
      drawerItems.classList.remove('is-empty');
    }

    var self = this;
    setTimeout(function() {
      self.open();
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    selector = selector || '.shopify-section';
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector) {
    selector = selector || '.shopify-section';
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  handleBodyClick(evt) {
    var target = evt.target;
    if (target.closest('.sk-cart-dropdown__panel')) return;
    if (target.closest('#cart-icon-bubble')) return;
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.sk-cart-dropdown__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* /cart page redirect to homepage */
(function() {
  if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
    window.location.replace('/');
  }
})();
